import type { CampaignTask } from '@bvengineering/cas-member-gateway-service-client';
import { isSupportedTaskType } from './taskTypes';
import { isTaskSubmittable } from './taskState';

type Tasks = CampaignTask[] | null | undefined;

/** True when at least one supported task is ready to submit (not validating, not done). */
export function hasSubmittableTask(tasks: Tasks): boolean {
  return (tasks ?? [])
    .filter((task) => isSupportedTaskType(task.type))
    .some((task) => isTaskSubmittable(task.state));
}
